import { DropdownMenu } from '@paypalcorp/pp-react'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import React, { EventHandler, useEffect, useState } from 'react'
import { useApplicationContext } from '../../../provider'
import { isBrowser } from '../../../react-utils'
import { PaymentsDropdownContainer } from './payments-dropdown-container'
import {
  paymentDropdownAllOptions,
  paymentDropdownOptions,
  paymentListRegex,
} from './utils'

export const PaymentsDropdown = () => {
  const [currentSelection, setCurrentSelection] = useState('')
  const { paymentSelection, updatePaymentSelection } = useApplicationContext()

  const { pathname } = useLocation()

  const handleOnChange: EventHandler<any> = (event: any) => {
    const paymentMethod = event.target.value

    if (paymentMethod !== paymentSelection) {
      const data = {
        product: 'payment_menthods',
        event_name: 'payment_menthods_filter_clicked',
        event_props: 'payment_menthods_selected,life_cycle_product',
        payment_menthods_filter_name: paymentMethod,
        life_cycle_product: 'developer_docs',
      }

      isBrowser &&
        //@ts-ignore
        window?.PAYPAL?.analytics?.instance?.recordClick({
          data,
        })
    }

    updatePaymentSelection(paymentMethod)
    let newUrl: any =
      isBrowser && pathname.replace(paymentListRegex, `${paymentMethod}`)

    navigate(newUrl)
  }

  useEffect(() => {
    const allDropdownOptions = paymentDropdownAllOptions.filter((val) =>
      pathname.includes(val.value),
    )

    for (let i = 0; i < allDropdownOptions.length; i++) {
      const element = allDropdownOptions[i]
      setCurrentSelection(element.value)
    }
  }, [pathname])

  const paymentOptions = () => {
    if (pathname && pathname.includes('js-sdk'))
      return paymentDropdownAllOptions

    return paymentDropdownOptions
  }

  return (
    <PaymentsDropdownContainer>
      <DropdownMenu
        id="withImages"
        label="Select a payment method"
        options={paymentOptions()}
        value={currentSelection}
        onChange={handleOnChange}
        className="paymentDropdown"
      />
    </PaymentsDropdownContainer>
  )
}
